
export interface IToggleSingleFilter {
  filterName: string;
  value: string;
  singleSelection: boolean;
}
export class ToggleSingleFilter implements IToggleSingleFilter {
  constructor(
    public filterName: string,
    public value: string,
    public singleSelection: boolean,
  ) { }
}

export interface IChangeManyFilterItems {
  filterName: string;
  values: string[];
  isCustom?: boolean;
}
export class ChangeManyFilterItems implements IChangeManyFilterItems {
  constructor(
    public filterName: string,
    public values: string[],
    public isCustom: boolean
  ) { }
}


export interface IShortListItem {
  id: number;
  type: string;
  cc: string;
  modelsId: number;
}
export class ShortListItem implements IShortListItem {
  constructor(
    public id: number,
    public type: string,
    public cc: string,
    public modelsId: number
  ) { }
}
